export default "__VITE_ASSET__BgoOs6Rg__"